import { useContext } from 'react';

import { ChatHistoryContext } from '../context/ChatHistoryContext';

export function useChatHistoryContext() {
  const ctx = useContext(ChatHistoryContext);

  if (!ctx) throw new Error('ChatHistoryContext must be used within a provider');

  return ctx;
}
